import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { HashRouter, BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from './store'
import ScrollTop from './scroll';

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
    {/* <BrowserRouter basename="/wallet/"> */}
      <React.StrictMode>
        <ScrollTop />
        <App />
      </React.StrictMode>
    {/* </BrowserRouter> */}
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);
